import { storage_url } from './../../functions/shared-functions';
import { Component, Input, OnInit, OnChanges, SimpleChanges, OnDestroy, ViewChild } from '@angular/core';
import { NgbCarousel, NgbSlideEvent, NgbSlideEventSource } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss']
})
export class CarouselComponent implements OnInit, OnChanges, OnDestroy {

  @Input() attachments = []
  @Input() storage_url
  interval;
  errCount = 0;
  paused = false;
  unpauseOnArrow = false;
  pauseOnIndicator = false;
  pauseOnHover = true;
  pauseOnFocus = true;

  @ViewChild('carousel', { static: true }) carousel: NgbCarousel;

  constructor() { }

  ngOnInit(): void {
    let i = 0;
    // this.interval = setInterval(() => {
    // if (this.attachments && this.attachments.length) {
    //   if (i < this.attachments.length - 1) {
    //     i++;
    //   }
    //   else {
    //     i = 0;
    //   }
    //   try {
    //     let el: any = document.getElementById('slide' + i);
    //     el.checked = true;
    //   }
    //   catch (err) {
    //     console.log(err)
    //     this.errCount++;
    //     if (this.errCount > 2) {
    //       clearInterval(this.interval)
    //     }
    //   }
    // }
    // else {
    //   clearInterval(this.interval)
    // }
    // }, 8000)

  }
  ngOnChanges(ev: SimpleChanges): void {
    if (ev && ev.attachments) {
      this.attachments = ev.attachments.currentValue
    }
  }
  ngOnDestroy(): void {
    if (this.interval) {
      clearInterval(this.interval)
    }
  }

  onSlide(slideEvent: NgbSlideEvent) {
    if (
      this.unpauseOnArrow &&
      slideEvent.paused &&
      (slideEvent.source === NgbSlideEventSource.ARROW_LEFT || slideEvent.source === NgbSlideEventSource.ARROW_RIGHT)
    ) {
      this.togglePaused();
    }
    if (this.pauseOnIndicator && !slideEvent.paused && slideEvent.source === NgbSlideEventSource.INDICATOR) {
      this.togglePaused();
    }
  }


  togglePaused() {
    if (this.paused) {
      this.carousel.cycle();
    } else {
      this.carousel.pause();
    }
    this.paused = !this.paused;
  }

}
